import React, { useState } from 'react'

import { Button, Input, InputFile, Row, Span } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useLoading, useModal, useMovement } from 'hooks'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Entity } from 'pages/Supplier/MovMensal/types'
import { MovimentacaoMensalServices } from 'services/Supplier/MovMensal'
import { COLORS, FORMAT, SPACING } from 'utils'

import { ModalNovaAddEfetivo, TableVisaoIndividual } from '..'

import { createArrayCopy } from 'utils/functions'

export interface IVisaoTableAtual {
  listaAtual: Entity[]
  handleFilterEfetivos: (_query: string, _entity: Entity) => void
  handleUploadEfetivos: (_e) => void
}

const VisaoTableAtual = ({
  listaAtual,
  handleFilterEfetivos,
  handleUploadEfetivos
}: IVisaoTableAtual) => {
  const {
    selectedMovement,
    movState,
    setMovState,
    parametrization,
    handleBlock,
    competenciaSelecionada,
    handleError,
    blockIndividualVision,
    dataAtuacaoInvalida,
    setBlockVerifyIndividual,
    isSomenteCompartilhado,
    isSemMobilizacao
  } = useMovement()
  const { showModal } = useModal()
  const { setLoading } = useLoading()
  const [showAddEfetivo, setShowAddEfetivo] = useState<boolean>(false)
  const [pesquisaGeral, setPesquisaGeral] = useState<string>('')

  const handleAddEfetivo = (data) => {
    handleBlock(true, 'visaoTotal')
    data.fornecedorId = selectedMovement.fornecedorId
    setBlockVerifyIndividual(false)
    setMovState((old) => ({
      ...old,
      compAtual: [...old.compAtual, {
        ...data,
        nmColaborador: data.nmColaborador.toUpperCase()
      }]
    }))
  }

  const handleUpdateEfetivo = (data, index) => {
    handleBlock(true, 'visaoTotal')
    const cpy = createArrayCopy(movState.compAtual)
    const indexArr = cpy.findIndex((el) => el.index === index)
    cpy.splice(indexArr, 1, {
      ...data,
      nmColaborador: data.nmColaborador.toUpperCase()
    })
    setMovState((old) => ({
      ...old,
      compAtual: cpy
    }))
    setBlockVerifyIndividual(false)
    showModal({
      hideButtonCancel: true,
      message: `Linha:${index}, ${data.nmColaborador} foi alterado.`,
      txtButtonConfirm: 'Fechar',
      type: 'success'
    })
  }

  const handleDeleteEfetivo = (index) =>
    showModal({
      handleConfirm: () => {
        setBlockVerifyIndividual(false)
        handleBlock(true, 'visaoTotal')
        const cpy = createArrayCopy(movState.compAtual)
        const indexArr = cpy.findIndex((el) => el.index === index)
        if (indexArr !== -1) {
          cpy[indexArr].flDelete = true;
        }
        setMovState((old) => ({
          ...old,
          compAtual: cpy
        }))
      },
      message: 'Tem certeza deseja deletar?',
      type: 'alert'
    })

  const handleDownloadTableCompAtual = async () => {
    setLoading('loading')
    try {
      const responseDownload =
        await MovimentacaoMensalServices().downloadVisaoIndividual(
          movState.compAtual
        )

      if (responseDownload.status !== 200)
        throw Error('Não foi possivel enviar efetivos')

      downloadURI(
        responseDownload.data,
        `efetivos-competencia-${competenciaSelecionada}.xls`
      )
      setLoading('idle')
    } catch (error: any) {
      handleError(error)
    }
  }

  const downloadURI = (uri, name) => {
    const link = document.createElement('a')
    link.download = name
    link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${uri}`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleGeneratePDF = () => {
    const optsCategoria = {
      A: 'Administrativo',
      O: 'Operacional'
    }

    const optsNacionalidade = {
      B: 'Brasileiro',
      E: 'Estrangeiro'
    }

    const optsGenero = {
      F: 'Feminino',
      M: 'Masculino',
      O: 'Prefiro não informar'
    }

    const doc = new jsPDF('p', 'pt', 'a4')
    doc.text(`Competencia Atual ${selectedMovement?.mesAno}`, 20, 25)

    let headerTable = [
      'Nacionalidade',
      'CPF/Passaporte',
      'Gênero',
      'Nome',
      'Status',
      'Data Admissão',
      'Data Demissão',
      'Tipo Efetivo',
      'Função',
      'Categoria',
      'Competência',
      'Compartilhados'
    ]
    let tableRows
    if (parametrization?.flValorHeSalarioBasePorColaborador) {
      headerTable = [
        'Nacionalidade',
        'CPF/Passaporte',
        'Gênero',
        'Nome',
        'Status',
        'Data Admissão',
        'Data Demissão',
        'Tipo Efetivo',
        'Função',
        'Categoria',
        'Competência',
        'Compartilhados',
        'Valor Hora Extra',
        'Salário Base'
      ]

      tableRows = movState.compAtual?.map((el: Entity) => {
        return [
          optsNacionalidade[el.cdNacionalidade.trim().toUpperCase()],
          FORMAT.documento(el.cdCpfPassaporte),
          optsGenero[el.cdGenero.trim().toUpperCase()] || '- - - -',
          el.nmColaborador,
          el.cdStatus,
          FORMAT.formatDDMMYYYY(el.dtAdmissao),
          el.dtDemissao ? FORMAT.formatDDMMYYYY(el.dtDemissao) : '- - - -',
          el.cdTipoEfetivo,
          el.txFuncao,
          optsCategoria[el.cdCategoria.trim().toUpperCase()] || '- - - -',
          selectedMovement?.mesAno,
          '- - - -',
          FORMAT.currency(el.vlHoraExtras) || '- - - -',
          FORMAT.currency(el.vlSalBase) || '- - - -'
        ]
      })
    } else {
      headerTable = [
        'Nacionalidade',
        'CPF/Passaporte',
        'Gênero',
        'Nome',
        'Status',
        'Data Admissão',
        'Data Demissão',
        'Tipo Efetivo',
        'Função',
        'Categoria',
        'Competência',
        'Compartilhados'
      ]
      tableRows = movState.compAtual?.map((el: Entity) => {
        return [
          el.cdNacionalidade.trim() === 'B' ? 'Brasileiro' : 'Estrangeiro',
          FORMAT.documento(el.cdCpfPassaporte),
          el.cdGenero,
          el.nmColaborador,
          el.cdStatus,
          FORMAT.formatDDMMYYYY(el.dtAdmissao),
          el.dtDemissao ? FORMAT.formatDDMMYYYY(el.dtDemissao) : '- - - -',
          el.cdTipoEfetivo,
          el.txFuncao,
          el.cdCategoria,
          selectedMovement?.mesAno,
          el.cdContrato,
        ]
      })
    }

    autoTable(doc, {
      theme: 'grid',
      body: tableRows,
      headStyles: {
        fillColor: COLORS.tableColor,
        textColor: COLORS.blueFonts,
        halign: 'center'
      },
      bodyStyles: {
        halign: 'center',
        valign: 'middle'
      },
      head: [headerTable],
      styles: { fontSize: 5 }
    })
    doc.save(`${selectedMovement?.mesAno}-Competencia-atual.pdf`)
  }

  const isDisablePdfEndExcelButtons = (): boolean => {
    const enableButton = false
    const disableButton = true

    if (isSemMobilizacao) {
      return disableButton
    }

    return enableButton
  }

  const isDisableButtons = (): boolean => {
    const enableButton = false
    const disableButton = true

    if (
      blockIndividualVision ||
      !movState.isCompetenciaAtual ||
      dataAtuacaoInvalida
    ) {
      return disableButton
    }

    return enableButton
  }

  return (
    <>
      <Row
        justifyContent="start"
        alignItems="center"
        marginTop={SPACING.spacing20}
        marginBottom={SPACING.spacing20}
      >
        <Span
          text={`Competência Atual (${FORMAT.competencia(
            selectedMovement?.mesAno
          )})`}
          fontWeight="700"
          fontSize="16px"
        />
      </Row>
      <Row alignItems="center" justifyContent="space-between">
        <InputFile
          fileNameProp="false"
          onChange={handleUploadEfetivos}
          disabled={isDisableButtons()}
          disabledInput={isDisableButtons()}
          acceptFiles=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
        <Input
          placeholder=""
          value={pesquisaGeral}
          onChange={(e) => setPesquisaGeral(e.target.value)}
          label="Pesquisa Geral"
          inputIcon={<MagnifyingGlassIcon />}
        />
      </Row>
      <TableVisaoIndividual
        tableData={listaAtual
          ?.filter((data) => handleFilterEfetivos(pesquisaGeral, data))
          .filter((data) => !data.flDelete) // Filtra os itens com flDelete igual a true
        }
        deleteEfetivo={handleDeleteEfetivo}
        isCompetenciaAtual={movState.isCompetenciaAtual}
        updateEfetivo={handleUpdateEfetivo}
        dadosParametrizacao={parametrization}
        bloquearAcoes={blockIndividualVision}
        competenciaAtual={selectedMovement?.mesAno}
        listaAtual={listaAtual}
      />
      <Row
        alignItems="center"
        justifyContent="space-between"
        marginTop={SPACING.spacing20}
      >
        <Row>
          <ExcelIcon
            disabled={isDisablePdfEndExcelButtons()}
            onClick={handleDownloadTableCompAtual}
          />
          <PdfIcon
            onClick={handleGeneratePDF}
            marginLeft={SPACING.spacing20}
            disabled={isDisablePdfEndExcelButtons()}
          />
        </Row>
        <Button
          text="+ Adicionar Linha"
          onClick={() => setShowAddEfetivo(true)}
          disabled={isDisableButtons()}
        />
        {!!showAddEfetivo && (
          <ModalNovaAddEfetivo
            showModal={showAddEfetivo}
            toggleModal={() => setShowAddEfetivo(false)}
            onSubmit={handleAddEfetivo}
            competenciaAtual={selectedMovement?.mesAno}
            dadosParametrizacao={parametrization}
            listaAtual={listaAtual}
          />
        )}
      </Row>
    </>
  )
}

export default VisaoTableAtual
